import React, { Fragment, useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Popover, Select, Text, Popup } from './';
import MUIDataTable from "mui-datatables";
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import RemoveIcon from '@material-ui/icons/Remove';
import TableBody from '@material-ui/core/TableBody';
import Loader from './Loader';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Form, Field } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import Filter from './Filter';
import ColumnOrder from "./ColumnOrder";
import { connect } from 'react-redux';
import axios from 'axios';


function Table(props){
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState((window.innerHeight > 850)?100:20);
  const [switch_off, setSwitchOff] = useState(false);
  const [download_popup, setDownloadPopup] = useState(false);
  const [total_amount, setTotalAmount] = useState(0);
  const [loading_icon, setLoadingIcon] = useState(false);
  const [prospect_batch_id, setProspectBatchId] = useState(undefined);
  const [expandedRow, setExpandedRow] = useState(null); // Newly added state for expanded row
  const [download_step, setDownloadStep]=useState('download_type_decision');
  const [csv_original, setCsvOriginal]=useState(false);
  let processed_ids=useRef([]); //THIS IS NECESSARY COZ ON ROW COUNT OR PAGE CHANGE TABLE DEFAULTS TO UNSELECTED. IF SELECT ALL IS SELECTED, THEN IT SHOULD DEFAULT NEW IDS TO SLEECTED
  let new_selected =(props.selected==undefined)?[]:JSON.parse(JSON.stringify(props.selected)); let update_selected=false;
  if(processed_ids.current.length<props.rows.length){for(let r of props.rows){if (processed_ids.current.includes(r.id) == false) {
    processed_ids.current.push(r.id);
    if(props.selected_all==true && new_selected.includes(r.id)==false){update_selected=true; new_selected.push(r.id)}
  }} if(update_selected==true && props.setSelected!=undefined){props.setSelected(new_selected);}}
  //END THE PROCESSED IDS SECTION.



  let prl_account=false;
  if(props.workspace!=undefined){
      for(let x of props.workspace.customer_of_special_services){
          if(x.new!=true && (x.workspace_default_special_service.rec=='SCORING' || x.workspace_default_special_service_id==1)){prl_account=true;}
      }
  }
  let first_check_jumpstart=useRef(true); if(first_check_jumpstart.current==true && prl_account==true){first_check_jumpstart.current=false; setDownloadStep('jumpstart_default');}
  console.log(props, 'TABLE PROPS');
  let search_timeout = useRef(undefined);
  let current_columns = [];
  let columns = [];
  let rows = [];
  let k_arr = window.location.href.split('/k/');
  let k = k_arr.length > 1 ? k_arr[1].split('/')[0] : undefined;
  let invisible_columns = k == undefined ? [] : JSON.parse(atob(decodeURIComponent(k)));
  console.log(k_arr, k, invisible_columns);
    let index=0;
    if(props.headers!=undefined){for(let col of props.headers){let col_style={}; if(col.style!=undefined){col_style=col.style;} if(col.id=='icon'){col_style.left=(props.sub_rows==undefined)?'45px':'65px';} if(col.options==undefined){col.options={}} col.options.display=(invisible_columns.includes(col.id)==true)?false:true; if(col.options.display!=false){current_columns.push(col.id);} columns.push({name:col.id, label:col.label, style:col_style, options:{setCellHeaderProps:()=>{return {style:{whiteSpace:'nowrap', maxWidth:(col.maxWidth!=undefined)?col.maxWidth:'80px', overflowX:'hidden', ...col_style}}}, setCellProps:(ce,r,c)=>{return {style:{whiteSpace:'nowrap', fontSize:'12px', maxWidth:(col.maxWidth!=undefined)?col.maxWidth:'80px', overflowX:'hidden', ...col_style}}}, ...col.options}});}}
    if(props.rows!=undefined){let i=0; for(let r of props.rows){
      if(i>=(page*rowsPerPage)){if(i>=((page+1)*rowsPerPage)){break;}else{let n={}; for(let key in r){n[key]=r[key]} rows.push(n);}} i+=1;
    }}

    console.log('COLUMNsdfS', columns, current_columns)

  //  function requestDate(){props.getMoreData({page:page, rowsPerPage:rowsPerPage, filter:'sadf', query:'', list_id:'', filter_id:''});}

    function resetTable(x=0){setPage(x); setRowsPerPage((window.innerHeight > 850)?100:20); setSwitchOff(true); props.setSelected([]); props.setSelectedAll(false);}
    useEffect(()=>{window.setTablePage=resetTable; if(props.resetTableFunc!=undefined){props.resetTableFunc(resetTable);}},[])
    console.log(props.remote_data, 'REMOTE DATA', props.sort);


    function selectedIDsToIndexes(ids, rows){
      let selected_indexes=[]; let i=0;
      for(let r of rows){
        if(ids.includes(r.id)){selected_indexes.push(i);}
        i+=1;
      }
      return selected_indexes;
    }

    function selectedIndexesToIDs(indexes, rowsPerPage, page){
      console.log(props.rows, 'SELECTED ROW INDEX TO ID', props.selected, indexes, rowsPerPage, page);
      let current_selected=JSON.parse(JSON.stringify(props.selected));
      let non_selected_ids=[];
      for (let i = 0; i < rowsPerPage; i++) {
        if (props.rows[i + (rowsPerPage * page)]!=undefined){
          let id = props.rows[i + (rowsPerPage * page)].id;
          if(indexes.includes(i)){if (current_selected.includes(id) == false) { current_selected.push(id); }}
          else{non_selected_ids.push(id);}
        }  
      }
      let new_current_selected=[]; for(let cs of current_selected){if(non_selected_ids.includes(cs)==false){new_current_selected.push(cs);}}    
      console.log('SELECTED ROW 2', current_selected); 
      return new_current_selected;
    }

    


    const options = {
      serverSide: true,
      onTableChange:(props.remote_data==undefined)?null:(action, tableState) => {
        let invisible_columns=[]; for(let c of tableState.columns){if(c.display=='false'){invisible_columns.push(c.name);}}
        console.log(invisible_columns, 'INVISIBLE COLUMNS');
        let ice=encodeURIComponent(btoa(JSON.stringify(invisible_columns)));
        let url=window.location.pathname;
        let o_url=url;
        if(action=='viewColumnsChange'){
          url=url.split('/k/')[0]+'/k/'+ice+'/';
          if(o_url.split('/k/')[1]!=undefined && o_url.split('/k/')[1].split('/')[1]!=undefined){let i=0; for(let ss of o_url.split('/k/')[1].split('/')){if(i!=0 && ss!=undefined && ss!='' && ss!=null){url=url+ss+'/';} i+=1;}}
          window.setTimeout(function(){props.history.push(url);},100);
        }else if(action=='sort'){
          setPage(0);
          let url=window.location.pathname; url=url.split('/f')[0].split('/q')[0].split('/o')[0]; url=url+'/o/'+encodeURIComponent(btoa(JSON.stringify(tableState.sortOrder))); if(props.remote_data.query!=undefined){url=url+'/q/'+encodeURIComponent(btoa(props.remote_data.query));} if(props.remote_data.filter!=undefined){url=url+'/f/'+encodeURIComponent(btoa(JSON.stringify(props.remote_data.filter)));}
          let o_url=url;
          url=url.split('/k/')[0]+'/k/'+ice+'/';
          if(o_url.split('/k/')[1]!=undefined && o_url.split('/k/')[1].split('/')[1]!=undefined){let i=0; for(let ss of o_url.split('/k/')[1].split('/')){if(i!=0 && ss!=undefined && ss!='' && ss!=null){url=url+ss+'/';} i+=1;}}
          props.history.push(url);
        }else{
          let x=(tableState.page+1)*tableState.rowsPerPage;
          if(action=='search'){setPage(0); if(search_timeout.current!=undefined){clearTimeout(search_timeout.current);} search_timeout.current = setTimeout(function(){
            let url=window.location.pathname; url=url.split('/f')[0].split('/q')[0]; if(tableState.searchText!=undefined && tableState.searchText!=''){url=url+'/q/'+encodeURIComponent(btoa(tableState.searchText));} if(props.remote_data.filter!=undefined){url=url+'/f/'+encodeURIComponent(btoa(JSON.stringify(props.remote_data.filter)));}
            if(window.location.pathname.includes('/k/')){url=url+'/k/'+window.location.pathname.split('/k/')[1].split('/')[0];}
            props.history.push(url);
          }, 2200);}
          if(x>props.remote_data.ids.length && (x-tableState.rowsPerPage)<props.remote_data.total && props.remote_data.ids.length!=props.remote_data.total && (props.remote_data.requested_pages.includes(tableState.page+1)==false || props.remote_data.rowsPerPage!=tableState.rowsPerPage)){props.request_data({...props.remote_data, page:tableState.page+1, rowsPerPage:tableState.rowsPerPage});}
        }

      },
      filter:(props.filter==undefined)?false:props.filter,
      filterType:'multiselect',
      responsive:'standard',
      tableBodyHeight:'calc(100vh - 240px)',
      tableBodyMaxHeight:'calc(100vh - 240px)',
      draggableColumns:true,
      page:page,
      sort:props.sort,
      searchOpen:(props.match.params.query==undefined)?false:true,
      sortOrder:(props.remote_data==undefined || props.remote_data.order==undefined)?'':props.remote_data.order,
      searchText:(props.remote_data==undefined || props.remote_data.query==undefined)?'':props.remote_data.query,
      rowsPerPage:rowsPerPage,
      setTableProps:()=>{return {size:'small'}},
      rowsSelected:selectedIDsToIndexes((props.selected==undefined)?[]:props.selected, rows),
      onDownload:(buildHead, buildBody, columns, data)=>{
        setDownloadPopup(true);
        return false;
      },
      print:false,
      onRowSelectionChange:(props.setSelected==undefined)?undefined:(current, all, rows)=>{
        props.setSelected(selectedIndexesToIDs(rows, rowsPerPage, page));
      },
      expandableRows:(props.sub_rows==undefined)?false:true, // Enable expandable rows
      renderExpandableRow: (rowData, rowMeta) => {
       console.log(rowData, rowMeta, props.sub_rows, props.headers);
        // Customize the expandable row here
        if(expandedRow!=rowMeta.rowIndex || props.sub_rows==undefined || props.sub_rows[rowMeta.rowIndex]==undefined){return(null)}
        return (<Fragment>{props.sub_rows[rowMeta.rowIndex].map(function(row){return(<TableRow style={{backgroundColor: '#f2f2f2',height: '30px', whiteSpace:'nowrap'}}>
            <TableCell/>
            {props.headers.map((h) =>{if((h.style!=undefined && h.style.display=='none') || (h.options!=undefined && h.options.display==false)){}else{
              return(
              <TableCell style={{fontSize:'12px', padding:'0px', paddingLeft:'16px'}}>{(row[h.id]==undefined)?undefined:row[h.id]}</TableCell>
            )}})}</TableRow>)})}</Fragment>);
      },
      isRowExpandable: (rowData, rowMeta) => true, // Make all rows expandable
      onRowExpansionChange: (currentExpandedRows, allExpandedRows) => {console.log(currentExpandedRows, allExpandedRows, 'EXPAND YOO');
        // Handle row expansion change
        const expandedRow = currentExpandedRows.length > 0 ? currentExpandedRows[currentExpandedRows.length - 1].index : null;
        setExpandedRow(expandedRow);
      },
      rowsExpanded: expandedRow !== null ? [expandedRow] : [], // Set the currently expanded row
      expandableRowsOnClick: true, // Allow expanding rows on click
    };

    console.log('OPTIONS', options);
    let csv_uploads=[];
    let first_time_down=useRef(true);
    if(switch_off==true){
      window.setTimeout(function(){setSwitchOff(false);},1);
      return (
        <div>
        {(props.filter==true)?<div style={{position:'absolute', zIndex:'10000', top:'8px', right:'30px'}}><Filter {...props} save_filter_option/></div>:null}</div>
      );
    }


    if(download_popup==true){
      if(props.csv_uploads==undefined){if(first_time_down.current==true){props.indexCsvUploads(); first_time_down.current=false;}}else if(props.workspace!=undefined && props.workspace.admin!=false){
        for(let cu of props.csv_uploads){
          csv_uploads.unshift({id:cu.id, value:cu.id, name:cu.name+' ('+cu.created_at.replace('T', ' ').split('.')[0]+')'});
        }
      }
    }
    console.log('BLOCK DOWNLOAD?');
    let block_download=true; if(props.workspace!=undefined && (props.workspace.backend_account==true || props.workspace.free_account==true || (props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial!=true) || props.workspace.allow_download_on_free_trial==true)){block_download=false;}
    console.log('YOO');

      // Function to handle row expansion
    const handleRowExpand = (row) => {
      console.log('EXPAN', row);
      setExpandedRow(row);
    };

    // Helper function to check if a row is expanded
    const isRowExpanded = (row) => {
      return row === expandedRow;
    };
    
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {(props.filter==true)?<div style={{position:'absolute', zIndex:'10000', top:'8px', right:'30px'}}><Filter {...props} save_filter_option/></div>:null}
      {(props.column_order == true) ? <div style={{ position: 'absolute', zIndex: '10000', top: '8px', right: '78px' }}><ColumnOrder {...props} /></div>:null}
      <MUIDataTable
        title={props.title}
        data={rows}
        columns={columns}
        options={options}
        components={{
          ExpandButton:(inner_props)=>{console.log(inner_props, 'EXPANND');return(<div style={{zIndex:'1', position:'relative', width:(props.sub_rows==undefined || props.sub_rows[inner_props.dataIndex]==undefined || props.sub_rows[inner_props.dataIndex].length==0)?'24px':undefined}}><div style={{position:'absolute', left:'0px', backgroundColor:'white', width:'calc(100% + 40px)', marginLeft:'-40px', marginTop:'-4px', paddingBottom:'8px', height:'100%', zIndex:'0'}}/><div style={{backgroundColor:'white'}}>{(props.sub_rows==undefined || props.sub_rows[inner_props.dataIndex]==undefined || props.sub_rows[inner_props.dataIndex].length==0)?null:<ExpandButton {...inner_props} expandedRows={[expandedRow]}/>}</div></div>)},
          Checkbox:(props.setSelectedAll==undefined)?undefined:(checkbox_props) => {let di=checkbox_props['data-index']; if(di==null && checkbox_props['data-description']!='row-select-header'){di=0;} console.log('CC', di, checkbox_props); return (<div style={{zIndex:'1', position:'relative'}}><div style={{position:'absolute', left:'0px', backgroundColor:'white', width:(props.sub_rows==undefined || props.sub_rows[di]==undefined || props.sub_rows[di].length==0)?'calc(100% + 40px)':'100%', marginLeft:(props.sub_rows==undefined || props.sub_rows[di]==undefined || props.sub_rows[di].length==0)?'-40px':'0px',height:'100%', zIndex:'0'}}/><Checkbox {...checkbox_props} id={(checkbox_props['data-description']=='row-select-header')?"header_checklist":undefined} onClick={(e)=>{e.stopPropagation(); e.preventDefault();}} onChange={(e)=>{if(checkbox_props['data-description']=='row-select-header'){console.log('SELECT ALL CHANGE', e.target.checked); props.setSelectedAll(e.target.checked); if(e.target.checked==true){props.setSelected(processed_ids.current);}else{props.setSelected([]);}}; checkbox_props.onChange(e);}} value={props.selected_all} style={{marginTop:'-5px', marginBottom:'-5px', zIndex:'1'}}/></div>);},
          TableBody:(rows.length==0)?(body_props)=>{return(<div style={{zIndex:'100', position:'absolute', width:'100%', height:'100%', top:'0px', display:'flex', justifyContent:'center'}}>{(props.total=='empty')?null:<Loader embed loading />}</div>)}:undefined,
          TableToolbarSelect:(props.selectBar==undefined)?undefined:(ps)=>{return(<div style={{height:'69px', width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>{props.selectBar}</div>)},
          TableFooter:(footer_props)=>{
            return(
              <div style={{boxShadow:'0 -5px 5px -5px #888'}}>
              <TablePagination
                rowsPerPageOptions={[20, 50, 100]}
                component="div"
                count={(props.total!=undefined)?(props.total=='empty')?0:props.total:rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={(e, v)=>{if(props.setPage!=undefined){props.setPage(v);} setPage(v);}}
                onChangeRowsPerPage={(e)=>{if(props.setRowsPerPage!=undefined){if(props.set_request_data!=undefined){props.set_request_data({requested_pages:[]});} props.setRowsPerPage(e.target.value);} setRowsPerPage(e.target.value); setPage(0);}}
              />
              </div>
            )
          }
      }}
      />
      {(download_popup==true)?<Popup always_open title={'Download data'} handleClose={()=>{setCsvOriginal(false); setProspectBatchId(undefined); setDownloadStep('download_type_decision'); setDownloadPopup(false); first_check_jumpstart.current=true;}} accept_button={(block_download==true || (download_step!='granular_column_selection' && (prl_account==true || download_step!='file_download_decision')))?undefined:'Download'} accept_button_click={(block_download==true)?undefined:(download_step=='file_download_decision' && prl_account!=true)?()=>{setDownloadStep('granular_column_selection')}:()=>{
              setLoadingIcon(true);
              let current_date = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
              let url ='/api/download_csv?maximum_amount='+total_amount;
              if(props.remote_data.filter!=undefined){url+='&filter='+JSON.stringify(props.remote_data.filter)}
              if(props.remote_data.order!=undefined){url+='&order='+JSON.stringify(props.remote_data.order)}
              if(props.remote_data.query!=undefined){url+='&query='+props.remote_data.query;}
              if(csv_original==true){let cols=['prospectsafari_id', 'prospectsafari_contact_id', 'prospectsafari_contact_phone_number_id', 'contact_phone_number', 'contact_phone_connection_rate']; for(let c of current_columns){if(c.includes('special_service')==true){cols.push(c);}}; url+='&columns='+JSON.stringify(cols);}else{url+='&columns='+JSON.stringify(current_columns);}
              if(prospect_batch_id!=undefined){url+='&prospect_batch_id='+prospect_batch_id;}

              let a = document.createElement('a'); a.href = url; a.download = 'prospectsafari_data_'+current_date+'.csv';
              document.body.appendChild(a); a.click(); a.remove();
              let dt=props.total*2;
              if(dt<1000){dt=3000;}
              window.setTimeout(function(){setLoadingIcon(false)},dt);
              setCsvOriginal(false); setProspectBatchId(undefined); setDownloadStep('download_type_decision'); setDownloadPopup(false); first_check_jumpstart.current=true;
        }} content={<div style={{minWidth:'600px'}}>{(block_download==true)?
          <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'60px', marginBottom:'90px', textAlign:'center'}}>{"You can only download your data once you are on a "}<a style={{cursor:'pointer'}} onClick={()=>{if(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true && (props.workspace.active_subscription.stripe_user==undefined || props.workspace.active_subscription.stripe_user.payment_method==false)){window.location.href='/my/personal/customer/portal';}else{window.location.href='/payments/active?end_free_trial=true'}}}>paid subscription</a></Typography>
          :
          (download_step=='download_type_decision' || (download_step=='jumpstart_default' && csv_uploads.length==0))?
            <Fragment>
            {(csv_uploads.length==0)?
              <Fragment>
                <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'80px', textAlign:'center'}}>{"Download the "+props.total+" rows currently selected."}</Typography>
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'20px'}}><Button color='primary' variant='contained' onClick={()=>{setDownloadStep('granular_column_selection')}}>Proceed</Button></div>
              </Fragment>
              :
              <Fragment>
                <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'30px', marginBottom:'30px', textAlign:'center'}}>{"Enriched version of a previously uploaded CSV, or the current selection ("+props.total+" rows)"}</Typography>
                <Grid container style={{width:'100%', marginTop:'40px', marginBottom:'60px'}}>
                  {(isScoringAccountNonAdmin(props.workspace, props.me)==true)?null:<Grid item xs={6} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{setDownloadStep('file_download_decision')}}>Previous Csv</Button></Grid>}
                  <Grid item xs={(isScoringAccountNonAdmin(props.workspace, props.me)==true)?12:6} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{setDownloadStep('granular_column_selection')}}>Current Rows</Button></Grid>
                </Grid>
              </Fragment>
            }
            </Fragment>
          :(download_step=='file_download_decision' || download_step=='jumpstart_default')?
            <Fragment>
              <Typography style={{width:'calc(100% - 100px)', marginLeft:'50px', marginTop:'30px', marginBottom:'10px'}}>{"Select a CSV:"}</Typography>
              <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}><div style={{width:'calc(100% - 80px)'}}><Select value={prospect_batch_id} onChange={(e)=>{setProspectBatchId(e.target.value)}} no_field select_data={csv_uploads}/></div></div>
              {(prl_account==true)?<Fragment><Typography style={{width:'calc(100% - 100px)', marginLeft:'50px', marginTop:'30px', marginBottom:'30px'}}>{(download_step=='jumpstart_default')?"Download original csv with JumpStart phone scoring data?":"Download original csv or original with enhanced data?"}</Typography>
              <Grid container style={{width:'100%', marginTop:'40px', marginBottom:'60px'}}><Grid item xs={6} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{setCsvOriginal(true); setDownloadStep('granular_column_selection')}}>{(download_step=='jumpstart_default')?'Download':'JumpStart'}</Button></Grid><Grid item xs={6} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>{(download_step=='jumpstart_default')?<Typography style={{textDecoration:'underline', cursor:'pointer'}} onClick={()=>{setDownloadStep('download_type_decision')}} color='primary'>More options</Typography>:<Button color='primary' variant='contained' onClick={()=>{setDownloadStep('granular_column_selection')}}>{'Enhanced'}</Button>}</Grid></Grid></Fragment>:<div style={{height:'120px'}}/>}
            </Fragment>
          :(download_step=='granular_column_selection')?
            <Fragment>
            <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'40px', marginBottom:'120px'}}>{(prospect_batch_id==undefined)?'All columns included in your view will be downloaded.':(csv_original==true)?'Your CSV will be donwloaded with exactly the same data you uploaded. Only JumpStart scoring columns will be added':'All csv headers will remain the same but your data will be as shown in ProspectSafari and extra columns will be included.'}</Typography>
            </Fragment>
        :null}</div>

      }/>:null}
      {(loading_icon==true)?<Loader loading_message="This operation may take up to a minute to complete" loading={true}/>:null}
      </div>
    );
}



const ExpandButton = ({
  areAllRowsExpanded,
  buttonClass,
  expandableRowsHeader,
  expandedRows,
  iconClass,
  iconIndeterminateClass,
  isHeaderCell,
  onExpand,
}) => {
  return (
    <>
      {isHeaderCell && !areAllRowsExpanded() && areAllRowsExpanded && expandedRows.length > 0 ? (
        <IconButton
          onClick={onExpand}
          style={{ padding: 0 }}
          disabled={expandableRowsHeader === false}
          className={buttonClass}>
          <RemoveIcon id="expandable-button" className={iconIndeterminateClass} />
        </IconButton>
      ) : (
        <IconButton
          onClick={onExpand}
          style={{ padding: 0 }}
          disabled={expandableRowsHeader === false}
          className={buttonClass}>
          {expandedRows.length > 0 ? (
            <KeyboardArrowLeftIcon id="expandable-button" className={iconClass} />
          ) : (
            <KeyboardArrowDownIcon id="expandable-button" className={iconClass} />
          )}
        </IconButton>
      )}
    </>
  );
};


export default connect(ss,dd)(Table);


function ss(state){
  return{
    csv_uploads:state.account.csv_uploads
  }
}

function dd(dispatch){
  return{
    indexCsvUploads:()=>{dispatch({type:'REQUEST_INDEX_CSV_UPLOADS'});}
  }
}

//<div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'30px'}}><TextField type='number' max={5000} size='small' variant='outlined' value={total_amount} onChange={(e)=>{setTotalAmount((props.total<e.target.value)?props.total:(e.target.value<0)?0:e.target.value)}} style={{maxWidth:'200px', width:'calc(100% - 40px)', backgroundColor:'#f7f9fc'}} /></div>
